export default __webpack_public_path__ + "static/1127-9d2e329433d727bee339b2414ac05ba5.gif";